/** @format */

import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { LongPressDirective } from './long-press.directive';

@Component({
  selector: 'shared-components-carousel-button',
  imports: [LongPressDirective, HmfButtonComponent],
  templateUrl: './carousel-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselButtonComponent {
  readonly previous = input(false);
  readonly showLeftArrow = input(false);
  readonly showRightArrow = input(false);
  readonly ariaLabel = input('');
  readonly size = input<'small' | 'medium' | 'large'>('medium');
  readonly iconSize = input<'small' | 'medium' | 'large'>('large');

  readonly clickEvent = output<boolean>();

  onClick(): void {
    this.clickEvent.emit(this.previous());
  }
}
